import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from 'pages/Home';
import { ProductWithData } from 'containers/ProductWithData';
import SearchPage from 'pages/SearchPage';
import TechnicalBulletin from 'pages/TechnicalBulletin';
import FittingInstructions from 'pages/FittingInstructions/FittingInstructions';
import TechnicalDocument from 'pages/TechnicalDocument/TechnicalDocument';

const Routes = () => {
  useEffect(() => {
    const { loadGTMScript } = window;
    if (loadGTMScript) loadGTMScript();
  }, []);

  return (
    <Switch>
      <Route path="/technical-bulletin/:alias" component={TechnicalBulletin} />
      <Route
        path="/fitting-instruction/:alias"
        component={FittingInstructions}
      />
      <Route path="/technical-document/:alias" component={TechnicalDocument} />
      <Route path="/search" component={SearchPage} />
      <Route
        path="/product/:articleId/:tabName"
        exact={false}
        strict={false}
        component={ProductWithData}
      />
      <Route component={Home} />
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/components/App/Routes.js